import { Component, OnInit } from "@angular/core";
import { DataService_StudentHallSweep } from "./shared/data.service";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { StudentHallSweepSelectRequest } from "./shared/StudentHallSweepSelectRequest";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DialogService } from "primeng/dynamicdialog";
import { ReportService } from "../../Report/report.service";
import * as moment from "moment";

@Component({
	selector: "app-student-hall-sweep",
	templateUrl: "./student-hall-sweep.component.html",
	styleUrls: ["./student-hall-sweep.component.css"],
})
export class StudentHallSweepComponent implements OnInit {
	constructor(
		private hsService: DataService_StudentHallSweep,
		private selectService: PersonSelectorService,
		private dialogService: DialogService,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadStats();
			this.loadTable();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////

	subscription: any;
	SelectedPerson: any;

	DateRangeOptionID: number = 0;
	lstDateRangeOption: any = [
		{
			ID: 0,
			Desc: "Today",
		},
		{
			ID: 1,
			Desc: "Last Month",
		},
		{
			ID: 2,
			Desc: "Last 2 Months",
		},
		{
			ID: 3,
			Desc: "Last 3 Months",
		},
		{
			ID: 99,
			Desc: "Current School Year",
		},
		{
			ID: -1,
			Desc: "Custom Date Range",
		},
		{
			ID: 12000,
			Desc: "All",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	TimeOptionID: number = 0; //0 All | 1 Start and End Time | 2 Period
	StartTime: Date = new Date();
	EndTime: Date = new Date();
	PeriodID: number;
	lstPeriod: any = [];

	ConsequenceCount: number = 0;
	AccumulationModeDesc: string = "";

	StatsLoading: boolean = false;
	TableLoading: boolean = false;
	Processing: boolean = false;

	//Table
	pagerows: any = 10;
	pagefirst: any = 0;
	SelectedHallSweep: any;
	lstHallSweep: any = [];

	lstConsequenceDesc: any = [];
	lstPeriodDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ConsequenceDesc", header: "Consequence" },
		{ field: "LevelID", header: "Count" },
		{ field: "ConsequenceTrigger", header: "Triggered at" },
		{ field: "AdminName", header: "Admin" },
		{ field: "c_dateDesc", header: "Date/Time" },
		{ field: "PeriodDesc", header: "Period" },
	];

	errorMessage: string = "";

	//////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////

	loadStats() {
		this.StatsLoading = true;
		this.ClearStats();

		var result = this.hsService.StudentInfoSelect(this.SelectedPerson.PersonID);
		result.subscribe(
			(response: any) => {
				if (response.ConsequenceCount != undefined) {
					this.ConsequenceCount = response.ConsequenceCount;
				}
				if (response.AccumulationModeDesc != undefined) {
					this.AccumulationModeDesc = response.AccumulationModeDesc;
				}
				if (response.lstPeriod != undefined) {
					this.lstPeriod = response.lstPeriod;

					if (response.lstPeriod.length > 0) {
						this.PeriodID = this.lstPeriod[0].PeriodID;
					} else {
						this.PeriodID = -1;
					}
				}

				this.StatsLoading = false;
			},
			(error) => {
				this.StatsLoading = false;
			}
		);
	}

	loadTable() {
		var fsDate = "";
		var feDate = "";
		var fsTime = "";
		var feTime = "";

		if (this.DateRangeOptionID == -1) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
				return;
			}
		}
		if (this.TimeOptionID == 1) {
			fsTime = moment(this.StartTime).format("HH:mm:00");
			feTime = moment(this.EndTime).format("HH:mm:00");

			if (String(fsTime).toLowerCase().indexOf("invalid") != -1 || String(feTime).toLowerCase().indexOf("invalid") != -1) {
				return;
			}
		}

		var fPeriod = -1;
		if (this.TimeOptionID == 2) {
			fPeriod = this.PeriodID;
		}

		this.TableLoading = true;

		var parms: StudentHallSweepSelectRequest = {
			PersonID: this.SelectedPerson.PersonID,
			LastXMonths: this.DateRangeOptionID,
			StartDate: fsDate,
			EndDate: feDate,
			TimeOptionID: this.TimeOptionID,
			StartTime: fsTime,
			EndTime: feTime,
			PeriodID: fPeriod,
		};

		var result = this.hsService.StudentHallSweepSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstHallSweep = response;

				//Load Data Filter Lists
				this.lstConsequenceDesc = Array.from(new Set(this.lstHallSweep.map((item: any) => item.ConsequenceDesc))).sort();
				this.lstPeriodDesc = Array.from(new Set(this.lstHallSweep.map((item: any) => item.PeriodDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadStats();
		this.loadTable();
	}

	onPrint() {
		this.errorMessage = "";

		//Error handling

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print demographics";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.Processing = true;

		var strParam = "";

		var fsDate = "";
		var feDate = "";
		var fsTime = "";
		var feTime = "";

		if (this.DateRangeOptionID == -1) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Date";
				return;
			}
			if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Date";
				return;
			}
		} else {
			fsDate = moment(new Date()).format("MM/DD/YYYY");
			feDate = moment(new Date()).format("MM/DD/YYYY");
		}

		if (this.TimeOptionID == 1) {
			fsTime = moment(this.StartTime).format("HH:mm:00");
			feTime = moment(this.EndTime).format("HH:mm:00");

			if (String(fsTime).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Time";
				return;
			}
			if (String(feTime).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Time";
				return;
			}
		}

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: LastXMonths
		strParam += "," + this.DateRangeOptionID + "|LastXMonths";

		//Parameter 3: StartDate
		strParam += "," + fsDate + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + feDate + "|EndDate";

		//Parameter 5: TimeOptionID
		strParam += "," + this.TimeOptionID + "|TimeOptionID";

		//Parameter 6: StartTime
		strParam += "," + fsTime + "|StartTime";

		//Parameter 7: EndTime
		strParam += "," + feTime + "|EndTime";

		//Parameter 8: PeriodID
		strParam += "," + this.PeriodID + "|PeriodID";

		//Parameter 9: ImageLogo
		strParam += "," + "8C87B20B-5813-4F74-8375-9898FD7B0C74" + "|ImageLogo";

		var reportID: any = 451;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.Processing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedHallSweep = val.data;
	}
	onRowUnselect(val) {
		this.SelectedHallSweep = null;
	}

	onDateRangeOptionIDChange(val) {
		this.DateRangeOptionID = val;

		this.loadTable();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}
		if (Number(moment(this.StartDate).format("YYYY")) < 2000) {
			return;
		}

		this.loadTable();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		var feDate = moment(this.EndDate).format("MM/DD/YYYY");
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}
		if (Number(moment(this.EndDate).format("YYYY")) < 2000) {
			return;
		}

		this.loadTable();
	}

	onStartTimeChange(val) {
		this.StartTime = val;

		if (this.TimeOptionID == 1) {
			var fsTime = moment(this.StartTime).format("HH:mm:00");

			if (String(fsTime).toLowerCase().indexOf("invalid") != -1) {
				return;
			}

			this.loadTable();
		}
	}

	onEndTimeChange(val) {
		this.EndTime = val;

		if (this.TimeOptionID == 1) {
			var feTime = moment(this.EndTime).format("HH:mm:00");

			if (String(feTime).toLowerCase().indexOf("invalid") != -1) {
				return;
			}

			this.loadTable();
		}
	}

	onPeriodChange(val) {
		this.PeriodID = val;

		if (this.TimeOptionID == 2) {
			this.loadTable();
		}
	}

	onTimeOptionIDChange(val) {
		this.TimeOptionID = val;

		this.loadTable();
	}

	//////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.StatsLoading == true || this.TableLoading == true || this.Processing == true;
	}

	ClearStats() {
		this.ConsequenceCount = 0;
		this.AccumulationModeDesc = "";
	}

	//////////////////////////////////////////////////////////////////////////
}
